// eslint-disable-next-line no-restricted-imports
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

const adfStreamStartingWrappers = ['```json', '<adf_input>'];
const adfStreamEndingWrappers = ['```', '</adf_input>'];
/**
 * Removes known wrapper strings that sometimes surround ADF JSON content generated by LLM models.
 * These wrappers make the content invalid JSON, preventing parsing by ADFStreamer.
 *
 * @param {string} content - The content to sanitize.
 * @returns The sanitized content with wrapper strings removed.
 * @example
 * sanitizeStreamContentForADFStreamer('```json{"type":"doc"}</adf_input>');
 * // returns '{"type":"doc"}'
 */
export function sanitizeStreamContentForADFStreamer(content: string): string {
	adfStreamStartingWrappers.forEach((wrapper) => {
		if (content.startsWith(wrapper)) {
			content = content.replace(wrapper, '');
		}
	});
	adfStreamEndingWrappers.forEach((wrapper) => {
		if (content.endsWith(wrapper)) {
			content = content.replace(wrapper, '');
		}
	});

	if (fg('platform_editor_ai_aifc_patch_ga_blockers')) {
		/**
		 * Special case: if the pattern is at the end (dangling /), we need to escape both quote and slash
		 * "Hello"/ -> "Hello\"\/ (this keeps both chars in the string and keeps string open for jsonrepair)
		 * Pattern: (^|[^\\])"\/"$ captures start or non-backslash char before "/" and at the end of the string
		 * This handles malformed JSON like "Hello"/ -> "Hello\"\/
		 */
		// eslint-disable-next-line require-unicode-regexp
		content = content.replace(/(^|[^\\])"\/$/g, '$1\\"\\/');

		/**
		 * For all other cases (not at the end)
		 * Escape unescaped double quotes followed by a forward slash
		 * Pattern: (^|[^\\])"\//g captures start or non-backslash char before "/"
		 * This handles malformed JSON like "Hello"/world" -> "Hello\"/world"
		 * It also ensures we don't capture JSON key/value pairs
		 */
		if (expValEquals('platform_editor_ai_fix_streaming_json_escape', 'isEnabled', true)) {
			// eslint-disable-next-line require-unicode-regexp
			content = content.replace(/(^|[^\\:])"\//g, '$1\\"/');
		} else {
			// eslint-disable-next-line require-unicode-regexp
			content = content.replace(/(^|[^\\])"\//g, '$1\\"/');
		}
	}

	return content;
}
